module.exports = __webpack_public_path__ + "static/img/footer_btn1_ewm.65fb74e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_btn1_ewm.png
// module id = +yME
// module chunks = 181